import MenuService from '@/services/MenuService';

export const state = () => ({
  data: {},
});

export const mutations = {
  setMenuData(state, { data }) {
    state.data = data;
  },
};

let fetchMenuPromise = null;

export const actions = {
  async fetchMenu({ commit, state }, force = false) {
    if (!force && state.data && Object.keys(state.data).length > 0) {
      return { data: state.data };
    }

    if (fetchMenuPromise) {
      return fetchMenuPromise;
    }

    const menuService = new MenuService({
      http: this.$http,
      auth: this.$auth,
    });

    fetchMenuPromise = (async () => {
      try {
        const response = await menuService.fetchMenu({
          languageIsoCode: this.$i18n.locale,
        });

        if (response && response.data) {
          commit('setMenuData', { data: response.data });
        }

        return response;
      } catch (error) {
        console.error('[MenuStore] Failed to fetch menu:', error);
        throw error;
      } finally {
        fetchMenuPromise = null;
      }
    })();

    return fetchMenuPromise;
  },
};
